module.exports = __webpack_public_path__ + "img/banner-11.c4ea0738.jpg";